
import React, { useEffect, useState } from "react";

import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";
import { vcsList } from "../../data/vcData";

import {
  placementDrives,
  selectedCandidates,
  trainingActivities,
} from "../../data/placementData";

import "./Placement.css";

// ==================================================
// PLACEMENT CAROUSEL IMAGES
// Images must be in public/placements/
// ==================================================

const placementImages = [
     { image: "/placements/p5.jpeg", title: "Placement Image 5" },
 
  { image: "/placements/p7.jpeg", title: "Placement Image 7" },
  { image: "/placements/p1.jpeg", title: "Placement Image 1" },
  { image: "/placements/p2.jpeg", title: "Placement Image 2" },
  { image: "/placements/p3.jpeg", title: "Placement Image 3" },
  { image: "/placements/p4.jpeg", title: "Placement Image 4" },
  { image: "/placements/p8.jpeg", title: "Placement Image 4" },
   { image: "/placements/p6.jpeg", title: "Placement Image 6" },
 
];

// ==================================================
// PLACEMENT COORDINATORS
// Replace placeholder details with actual information.
// ==================================================

const coordinators = [
  {
    name: "Dr. Gunda Surendra",
    designation: "Training & Placement Coordinator",
    department: "Business Management",
    image: "/businessmanagement/surendra.JPG",
  },
  {
    name: "A. Sreekanth",
    designation: "Training & Placement Coordinator",
    department: "Mechanical Engineering",
    image: "/mechanics/sreekanth.JPG",
  },
];

// ==================================================
// GALLERY IMAGES
// ==================================================

const galleryImages = [
  { image: "/placements/gallery1.jpeg", title: "Campus Placement Drive" },
  { image: "/placements/gallery2.jpeg", title: "Student Training Programme" },
  { image: "/placements/gallery3.jpeg", title: "Industry Interaction" },
  { image: "/placements/gallery4.jpeg", title: "Career Development Programme" },
  { image: "/placements/gallery5.jpeg", title: "Recruitment Activities" },
  { image: "/placements/gallery6.jpeg", title: "Student Participation" },
  { image: "/placements/gallery7.jpeg", title: "Interview Session" },
  { image: "/placements/gallery8.jpeg", title: "Group Discussion" },
  { image: "/placements/gallery9.jpeg", title: "Technical Training" },
  { image: "/placements/gallery10.jpeg", title: "Campus Recruitment" },
  { image: "/placements/gallery11.jpeg", title: "Industry Expert Session" },
  { image: "/placements/gallery12.jpeg", title: "Career Guidance" },
  { image: "/placements/gallery13.jpeg", title: "Student Workshop" },
  { image: "/placements/gallery14.jpeg", title: "Placement Orientation" },
  { image: "/placements/gallery15.jpeg", title: "Skill Development" },
  { image: "/placements/gallery16.jpeg", title: "Placement Activities" },
];

// ==================================================
// REUSABLE SECTION HEADING
// ==================================================

function SectionHeading({ title, subtitle }) {
  return (
    <div className="placement-section-heading">
      <h2>{title}</h2>
      {subtitle && <p>{subtitle}</p>}
      <div className="placement-heading-line" />
    </div>
  );
}

// ==================================================
// UPDATED SEVEN-IMAGE CAROUSEL
// ==================================================

function PlacementCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalSlides = placementImages.length;

  const previousSlide = () => {
    setCurrentIndex(
      (previous) => (previous - 1 + totalSlides) % totalSlides
    );
  };

  const nextSlide = () => {
    setCurrentIndex(
      (previous) => (previous + 1) % totalSlides
    );
  };

  // Automatically move to the next image every 4 seconds.
  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrentIndex(
        (previous) => (previous + 1) % totalSlides
      );
    }, 4000);

    return () => window.clearInterval(timer);
  }, [totalSlides]);

  return (
    <section
      className="placement-carousel"
      aria-label="Rayalaseema University placement images"
    >
      {placementImages.map((item, index) => (
        <div
          key={item.image}
          className={`placement-slide ${
            index === currentIndex ? "active" : ""
          }`}
          aria-hidden={index !== currentIndex}
        >
          <img
            src={item.image}
            alt={item.title}
            onLoad={() => {
              console.log("Placement image loaded:", item.image);
            }}
            onError={() => {
              console.error(
                "Placement image failed to load:",
                item.image
              );
            }}
          />

          <div className="placement-slide-overlay">
            {index === currentIndex && (
              <div className="placement-slide-content">
                {/* <span className="placement-eyebrow">
                  RAYALASEEMA UNIVERSITY
                </span>

                <h1>Training &amp; Placement Cell</h1>

                <p>
                  Empowering students through career development,
                  industry interaction, skill enhancement and
                  placement opportunities.
                </p> */}

                {/* <a
                  href="#placement-drives"
                  className="placement-slide-link"
                >
                  Explore Placements <span>→</span>
                </a> */}
              </div>
            )}
          </div>
        </div>
      ))}

      <button
        type="button"
        className="placement-carousel-btn prev"
        onClick={previousSlide}
        aria-label="Previous slide"
      >
        &#10094;
      </button>

      <button
        type="button"
        className="placement-carousel-btn next"
        onClick={nextSlide}
        aria-label="Next slide"
      >
        &#10095;
      </button>

      <div className="placement-carousel-dots">
        {placementImages.map((item, index) => (
          <button
            key={item.image}
            type="button"
            className={index === currentIndex ? "active" : ""}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Show slide ${index + 1}`}
            aria-current={
              index === currentIndex ? "true" : undefined
            }
          />
        ))}
      </div>
    </section>
  );
}

// ==================================================
// REUSABLE DATA TABLE
// ==================================================

function DataTable({ columns, rows, emptyMessage }) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return <p className="placement-empty">{emptyMessage}</p>;
  }

  return (
    <div className="placement-table-wrapper">
      <table className="placement-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key}>{column.label}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={row.id ?? rowIndex}>
              {columns.map((column) => (
                <td key={column.key}>
                  {column.render
                    ? column.render(row, rowIndex)
                    : row[column.key] ?? "—"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// ==================================================
// MAIN PLACEMENT PAGE
// ==================================================

export default function Placement() {
  const currentVC =
    vcsList.find((vc) => vc.id === 9) ||
    vcsList[vcsList.length - 1];

  const [candidateSearch, setCandidateSearch] = useState("");
  const [companyFilter, setCompanyFilter] = useState("All");
  const [galleryImage, setGalleryImage] = useState(null);

  const drives = Array.isArray(placementDrives)
    ? placementDrives
    : [];

  const candidates = Array.isArray(selectedCandidates)
    ? selectedCandidates
    : [];

  const trainings = Array.isArray(trainingActivities)
    ? trainingActivities
    : [];

  // Support different column names in imported spreadsheet data.
  const getValue = (row, possibleKeys) => {
    for (const key of possibleKeys) {
      if (
        row?.[key] !== undefined &&
        row?.[key] !== null &&
        row[key] !== ""
      ) {
        return row[key];
      }
    }

    return "—";
  };

  const companyNames = [
    ...new Set(
      candidates
        .map((candidate) =>
          getValue(candidate, [
            "company",
            "companyName",
            "Company Name",
          ])
        )
        .filter((company) => company !== "—")
    ),
  ];

  const filteredCandidates = candidates.filter((candidate) => {
    const studentName = String(
      getValue(candidate, [
        "studentName",
        "name",
        "Student Name",
        "student_name",
      ])
    ).toLowerCase();

    const company = String(
      getValue(candidate, [
        "company",
        "companyName",
        "Company Name",
      ])
    );

    const hallTicket = String(
      getValue(candidate, [
        "hallTicket",
        "hallTicketNumber",
        "rollNumber",
        "Hall Ticket No",
        "HT No",
      ])
    ).toLowerCase();

    const search = candidateSearch.trim().toLowerCase();

    const matchesSearch =
      !search ||
      studentName.includes(search) ||
      company.toLowerCase().includes(search) ||
      hallTicket.includes(search);

    const matchesCompany =
      companyFilter === "All" || company === companyFilter;

    return matchesSearch && matchesCompany;
  });

  const totalSelected = candidates.length;

  const totalEnrolled = drives.reduce((total, drive) => {
    const value = Number(
      getValue(drive, [
        "enrolled",
        "enrolledStudents",
        "Enrolled",
      ])
    );

    return total + (Number.isFinite(value) ? value : 0);
  }, 0);

  const totalDriveSelections = drives.reduce((total, drive) => {
    const value = Number(
      getValue(drive, [
        "selected",
        "selectedStudents",
        "Selected",
      ])
    );

    return total + (Number.isFinite(value) ? value : 0);
  }, 0);

  const formatDate = (value) => {
    if (!value || value === "—") return "—";

    if (value instanceof Date) {
      return value.toLocaleDateString("en-IN");
    }

    return String(value);
  };

  return (
    <>
      <Navbar />

      <main className="placement-page">
        {/* 1. HERO CAROUSEL */}

        <PlacementCarousel />

        {/* 2. INTRODUCTION */}

        <section className="placement-introduction">
          <div className="placement-container">
            <SectionHeading
              title="Training and Placement Cell"
              subtitle="Rayalaseema University, Kurnool, Andhra Pradesh"
            />

            <p className="placement-intro-text">
              The Training and Placement Cell of Rayalaseema
              University facilitates student career development
              through skill enhancement, industry interaction,
              internships, recruitment drives and professional
              training. The cell connects students with employment
              opportunities and helps them develop the knowledge,
              confidence and competencies required for their careers.
            </p>
          </div>
        </section>

        {/* 3. PLACEMENT STATISTICS */}

        <section className="placement-statistics">
          <div className="placement-container placement-statistics-grid">
            <div className="placement-stat-card">
              <span className="placement-stat-icon">🏢</span>
              <h3>{drives.length}</h3>
              <p>Placement Drives</p>
            </div>

            <div className="placement-stat-card">
              <span className="placement-stat-icon">🎓</span>
              <h3>{totalSelected}</h3>
              <p>Selected Student Records</p>
            </div>

            <div className="placement-stat-card">
              <span className="placement-stat-icon">👥</span>
              <h3>{totalEnrolled}</h3>
              <p>Students Enrolled in Drives</p>
            </div>

            <div className="placement-stat-card">
              <span className="placement-stat-icon">📚</span>
              <h3>{trainings.length}</h3>
              <p>Training Activities</p>
            </div>
          </div>

          
        </section>

        {/* 4. VICE-CHANCELLOR MESSAGE */}

        <section className="placement-vc-section">
          <div className="placement-container">
            {/* <SectionHeading
              title="Message from the Vice-Chancellor"
              subtitle="A vision for student success and employability"
            /> */}

            <div className="placement-vc-card">
              <div className="placement-vc-image">
                <img
                  src="/person/vicechancellor2.JPG"
                  alt={currentVC?.name || "Vice-Chancellor"}
                  onError={(event) => {
                    event.currentTarget.onerror = null;
                    event.currentTarget.src =
                      "/person/vicechancellor1.JPG";
                  }}
                />
              </div>

              <div className="placement-vc-content">
                <span className="placement-vc-label">
                 Hon'ble VICE-CHANCELLOR
                </span>

                <h3>
                  {currentVC?.name ||
                    "Prof. V. Venkata Basava Rao"}
                </h3>

                <p>
                  Education must empower students with knowledge,
                  practical skills, confidence and professional values.
                  Our university encourages industry interaction,
                  skill development, innovation and career-oriented
                  training so that students can prepare effectively
                  for emerging employment opportunities.
                </p>

                <p>
                  The Training and Placement Cell plays an important
                  role in strengthening the connection between academic
                  learning and professional practice. We encourage
                  students to make effective use of training programmes,
                  internships and placement opportunities.
                </p>

                <p className="placement-vc-signature">
                  {currentVC?.name ||
                    "Prof. V. Venkata Basava Rao"}
                  <span>Hon'ble Vice-Chancellor, Rayalaseema University</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 5. PLACEMENT COORDINATORS */}

        <section className="placement-coordinators-section">
          <div className="placement-container">
            <SectionHeading
              title="Placement Coordinators"
              subtitle="Guidance, training and career support"
            />

            <div className="placement-coordinator-grid">
              {coordinators.map((coordinator) => (
                <article
                  className="placement-coordinator-card"
                  key={coordinator.image}
                >
                  <div className="placement-coordinator-photo">
                    <img
                      src={coordinator.image}
                      alt={coordinator.name}
                      onError={(event) => {
                        event.currentTarget.style.display = "none";
                        event.currentTarget.parentElement.classList.add(
                          "placement-photo-missing"
                        );
                      }}
                    />

                    <span className="placement-photo-fallback">
                      {coordinator.name.charAt(0)}
                    </span>
                  </div>

                  <div className="placement-coordinator-info">
                    <h3>{coordinator.name}</h3>
                    <p className="placement-coordinator-designation">
                      {coordinator.designation}
                    </p>
                    <p>{coordinator.department}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* 6. TRAINING ACTIVITIES */}

        <section className="placement-training-section">
          <div className="placement-container">
            <SectionHeading
              title="Training Activities"
              subtitle="Skill development and industry-oriented programmes"
            />

            <DataTable
              rows={trainings}
              emptyMessage="Training activity details are not available."
              columns={[
                {
                  key: "serial",
                  label: "S.No.",
                  render: (_, index) => index + 1,
                },
                {
                  key: "startDate",
                  label: "Start Date",
                  render: (row) =>
                    formatDate(
                      getValue(row, [
                        "startDate",
                        "start_date",
                        "Start Date",
                        "From Date",
                      ])
                    ),
                },
                {
                  key: "endDate",
                  label: "End Date",
                  render: (row) =>
                    formatDate(
                      getValue(row, [
                        "endDate",
                        "end_date",
                        "End Date",
                        "To Date",
                      ])
                    ),
                },
                {
                  key: "duration",
                  label: "Duration",
                  render: (row) =>
                    getValue(row, ["duration", "Duration"]),
                },
                {
                  key: "organization",
                  label: "Organization",
                  render: (row) =>
                    getValue(row, [
                      "organization",
                      "company",
                      "organizationName",
                      "Organization",
                    ]),
                },
                {
                  key: "targetStudents",
                  label: "Target Students",
                  render: (row) =>
                    getValue(row, [
                      "targetStudents",
                      "target",
                      "Target Students",
                      "batch",
                    ]),
                },
              ]}
            />
          </div>
        </section>

        {/* 7. PLACEMENT DRIVES */}

        <section
          className="placement-drives-section"
          id="placement-drives"
        >
          <div className="placement-container">
            <SectionHeading
              title="Placement Drives"
              subtitle="Recruitment and internship opportunities"
            />

            <DataTable
              rows={drives}
              emptyMessage="Placement drive details are not available."
              columns={[
                {
                  key: "serial",
                  label: "S.No.",
                  render: (_, index) => index + 1,
                },
                {
                  key: "date",
                  label: "Date",
                  render: (row) =>
                    formatDate(
                      getValue(row, [
                        "date",
                        "driveDate",
                        "Date",
                        "Drive Date",
                      ])
                    ),
                },
                {
                  key: "company",
                  label: "Company / Organization",
                  render: (row) =>
                    getValue(row, [
                      "company",
                      "companyName",
                      "Company",
                      "Company Name",
                      "organization",
                    ]),
                },
                {
                  key: "role",
                  label: "Role / Programme",
                  render: (row) =>
                    getValue(row, [
                      "role",
                      "jobRole",
                      "programme",
                      "Role",
                      "Job Role",
                    ]),
                },
                {
                  key: "mode",
                  label: "Mode",
                  render: (row) =>
                    getValue(row, ["mode", "Mode"]),
                },
                {
                  key: "type",
                  label: "Type",
                  render: (row) =>
                    getValue(row, [
                      "type",
                      "driveType",
                      "Type",
                      "Drive Type",
                    ]),
                },
                {
                  key: "package",
                  label: "Package",
                  render: (row) =>
                    getValue(row, [
                      "package",
                      "salary",
                      "Package",
                      "Salary",
                    ]),
                },
                {
                  key: "target",
                  label: "Eligible Batch",
                  render: (row) =>
                    getValue(row, [
                      "target",
                      "targetBatch",
                      "eligibleBatch",
                      "Target Batch",
                    ]),
                },
                {
                  key: "enrolled",
                  label: "Enrolled",
                  render: (row) =>
                    getValue(row, [
                      "enrolled",
                      "enrolledStudents",
                      "Enrolled",
                    ]),
                },
                {
                  key: "selected",
                  label: "Selected",
                  render: (row) =>
                    getValue(row, [
                      "selected",
                      "selectedStudents",
                      "Selected",
                    ]),
                },
              ]}
            />
          </div>
        </section>

        {/* 8. SELECTED CANDIDATES */}

        <section className="placement-candidates-section">
          <div className="placement-container">
            <SectionHeading
              title="Selected Candidates"
              subtitle="Student selection details from placement records"
            />

            <div className="placement-candidate-toolbar">
              <input
                type="search"
                value={candidateSearch}
                onChange={(event) =>
                  setCandidateSearch(event.target.value)
                }
                placeholder="Search student, company or hall ticket..."
                aria-label="Search selected candidates"
              />

              <select
                value={companyFilter}
                onChange={(event) =>
                  setCompanyFilter(event.target.value)
                }
                aria-label="Filter by company"
              >
                <option value="All">All Companies</option>

                {companyNames.map((company) => (
                  <option value={company} key={company}>
                    {company}
                  </option>
                ))}
              </select>
            </div>

            <p className="placement-candidate-count">
              Showing {filteredCandidates.length} of{" "}
              {candidates.length} candidate records
            </p>

            <DataTable
              rows={filteredCandidates}
              emptyMessage="No candidate records match your search."
              columns={[
                {
                  key: "serial",
                  label: "S.No.",
                  render: (_, index) => index + 1,
                },
                {
                  key: "studentName",
                  label: "Student Name",
                  render: (row) =>
                    getValue(row, [
                      "studentName",
                      "name",
                      "Student Name",
                      "student_name",
                    ]),
                },
                {
                  key: "hallTicket",
                  label: "Hall Ticket Number",
                  render: (row) =>
                    getValue(row, [
                      "hallTicket",
                      "hallTicketNumber",
                      "rollNumber",
                      "Hall Ticket No",
                      "HT No",
                    ]),
                },
                {
                  key: "department",
                  label: "Department",
                  render: (row) =>
                    getValue(row, [
                      "department",
                      "course",
                      "Department",
                    ]),
                },
                {
                  key: "company",
                  label: "Company",
                  render: (row) =>
                    getValue(row, [
                      "company",
                      "companyName",
                      "Company Name",
                    ]),
                },
                {
                  key: "date",
                  label: "Selection / Drive Date",
                  render: (row) =>
                    formatDate(
                      getValue(row, [
                        "date",
                        "driveDate",
                        "selectionDate",
                        "Date",
                      ])
                    ),
                },
              ]}
            />
          </div>
        </section>

        {/* 9. PLACEMENT PHOTO GALLERY */}

        <section className="placement-gallery-section">
          <div className="placement-container">
            <SectionHeading
              title="Placement Gallery"
              subtitle="Snapshots of training, recruitment and student activities"
            />

            <div className="placement-gallery-grid">
              {galleryImages.map((item) => (
                <button
                  type="button"
                  className="placement-gallery-item"
                  key={item.image}
                  onClick={() => setGalleryImage(item)}
                  aria-label={`View ${item.title}`}
                >
                  <img src={item.image} alt={item.title} />

                  {/* <span className="placement-gallery-caption">
                    {item.title}
                  </span> */}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* 10. GALLERY IMAGE MODAL */}

        {galleryImage && (
          <div
            className="placement-lightbox"
            role="dialog"
            aria-modal="true"
            aria-label={galleryImage.title}
            onClick={() => setGalleryImage(null)}
          >
            <button
              type="button"
              className="placement-lightbox-close"
              onClick={() => setGalleryImage(null)}
              aria-label="Close image"
            >
              &times;
            </button>

            <div
              className="placement-lightbox-content"
              onClick={(event) => event.stopPropagation()}
            >
              <img
                src={galleryImage.image}
                alt={galleryImage.title}
              />

              <p>{galleryImage.title}</p>
            </div>
          </div>
        )}
      </main>

      <Footer />
    </>
  );
}
